import ContextBadges from "./ContextBadges";
import RelationshipBadge from "./RelationshipBadge";
import { contactProfileForEntry } from "../lib/privateContactProfile";

function initials(name) {
  return (name || "?")
    .trim()
    .split(/\s+/)
    .map((part) => part[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export default function RolodexResultCard({ entry, context, onClick }) {
  const profile = contactProfileForEntry(entry);
  const name = profile.full_name || entry.recipient_name || entry.recipient_phone || "Unknown";
  const contexts = ["professional", "personal"].filter((item) => entry.facets?.[item]);
  const facet =
    context !== "all" && entry.facets?.[context]
      ? entry.facets[context]
      : entry.facets?.professional || entry.facets?.personal || {};

  return (
    <button className="rolodex-result-card" onClick={() => onClick(entry)}>
      <span className="rolodex-result-avatar">{initials(name)}</span>
      <span className="rolodex-result-copy">
        <strong>{name}</strong>
        <span>{profile.role || profile.company || profile.organization || profile.school || facet.where_met || "In your rolodex"}</span>
      </span>
      <span className="rolodex-result-meta">
        <ContextBadges contexts={contexts} compact />
        {facet.relationship_type && <RelationshipBadge type={facet.relationship_type} />}
      </span>
    </button>
  );
}
